(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._errorWrapper_171rr_1{word-break:break-word}._copyIcon_171rr_5{cursor:pointer;color:var(--dixa-typography-color-secondary)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { gql as k, useQuery as pe, useLazyQuery as $e, useMutation as G, isApolloError as Fe, useApolloClient as Ue } from "@apollo/client";
import { getOperationName as z } from "@apollo/client/utilities";
import { jsx as r, jsxs as h, Fragment as B } from "react/jsx-runtime";
import { FormField as H, FieldWrapper as O, Badge as j, Icon as ee, FlexBox as N, Text as T, List as le, Banner as he, Button as W, Modal as Ge, ModalHead as He, ModalBody as qe, ModalFoot as Ke, Spinner as te, Tag as Qe, Tooltip as fe, FieldSwitch as Ve, InputSelectionList as ze, SelectionList as Je, FieldText as de } from "@dixa/lib-shared-habla";
import { Link as Ye } from "react-router-dom";
import { colors as P } from "@dixa/lib-shared-tokens";
import { useState as m, useEffect as S, createContext as Ce, useContext as ye, createElement as V, useCallback as U } from "react";
import { FormProvider as Ze, useController as je } from "react-hook-form";
import we from "moment";
import { useInterval as Xe } from "react-use";
import et from "lodash/lowerCase";
import tt from "lodash/upperFirst";
import { HookFormText as nt } from "lib-shared-hook-form";
import ot from "classnames";
import { MockedProvider as rt } from "@apollo/client/testing";
import { render as it } from "@testing-library/react";
const ne = k`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        additionalProperties
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`, be = k`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
    $renderConditions: [Management_JSONObject!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
        renderConditions: $renderConditions
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`, Ee = k`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
    $renderConditions: [Management_JSONObject!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
        renderConditions: $renderConditions
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`, Ae = k`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, fn = (e, t) => function(n, o) {
  return pe(n, {
    ...o,
    context: {
      operationName: z(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, Cn = (e, t) => function(n, o) {
  return $e(n, {
    ...o,
    context: {
      operationName: z(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, yn = (e, t, n) => function(o, i) {
  return n.query({
    query: o,
    variables: i,
    context: {
      operationName: z(o),
      widgetId: e,
      widgetType: t
    }
  });
}, wn = (e, t) => function(n, o) {
  return G(n, {
    ...o,
    context: {
      operationName: z(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, bn = ({
  getValueByKey: e
}) => {
  const t = e("dixaApiTokenId")?.value, n = e("dixaApiTokenName")?.value;
  return /* @__PURE__ */ r(H, { children: /* @__PURE__ */ r(O, { label: "Dixa API-Token", children: !n || !t ? /* @__PURE__ */ r(B, { children: "Something seems odd with the Api-Token. No name and/or id available." }) : /* @__PURE__ */ h(B, { children: [
    "A Dixa Token with the name",
    " ",
    /* @__PURE__ */ r(j, { variant: "secondary", size: "small", children: n }),
    " ",
    "was created.",
    " ",
    /* @__PURE__ */ r(Ye, { to: `/settings/integrations/api-tokens/${t}`, children: "You can visit it on the Api-Token page" }),
    "."
  ] }) }) });
}, st = ({
  error: e
}) => e.extensions?.integration?.code === "DIXA_HEADER_CHECK_ERROR", En = ({
  errors: e
}) => e.some((t) => st({ error: t })), at = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_AUTHORIZATION_ERROR", An = ({
  errors: e
}) => e.some((t) => at({ error: t })), ct = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_PERMISSION_ERROR", Nn = ({
  errors: e
}) => e.some((t) => ct({ error: t })), lt = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_SERVICE_UNAVAILABLE_ERROR", Sn = ({
  errors: e
}) => e.some((t) => lt({ error: t })), dt = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_NOT_FOUND_ERROR", vn = ({
  errors: e
}) => e.some((t) => dt({ error: t })), ut = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_CONFLICT_ERROR", Tn = ({
  errors: e
}) => e.some((t) => ut({ error: t })), gt = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_BAD_REQUEST_ERROR", Mn = ({
  errors: e
}) => e.some((t) => gt({ error: t })), mt = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_FORBIDDEN_ERROR", Dn = ({
  errors: e
}) => e.some((t) => mt({ error: t })), pt = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_TOO_MANY_REQUESTS_ERROR", On = ({
  errors: e
}) => e.some((t) => pt({ error: t })), ht = ({
  error: e
}) => e.extensions?.integration?.code === "WIDGET_MISCONFIGURED_ERROR", ft = ({
  errors: e
}) => e.some((t) => ht({ error: t })), Ct = (e) => {
  const { delay: t = 2e3 } = e || {}, [n, o] = m(!1);
  return S(() => {
    const s = n ? window.setTimeout(() => o(!1), t) : void 0;
    return () => window.clearTimeout(s);
  }, [t, n]), { isCopied: n, copy: (s) => {
    navigator.clipboard.writeText(s), o(!0);
  } };
}, yt = "_errorWrapper_171rr_1", wt = "_copyIcon_171rr_5", Y = {
  errorWrapper: yt,
  copyIcon: wt
}, Ne = ({
  error: e,
  retry: t,
  isMisconfigured: n = !1,
  hideCopyButton: o = !1
}) => {
  const s = e && Fe(e) && e?.graphQLErrors?.length > 0, { isCopied: a, copy: u } = Ct(), g = /* @__PURE__ */ r(
    ee,
    {
      color: P.red[500],
      size: 16,
      name: "exclamation-triangle-filled"
    }
  );
  if (n || s && ft({
    errors: e.graphQLErrors
  }))
    return /* @__PURE__ */ h(N, { margin: "0 0 100", padding: "200", className: Y.errorWrapper, children: [
      /* @__PURE__ */ r(N, { margin: "0 300 0 0", alignItems: "center", children: g }),
      /* @__PURE__ */ r(T.Paragraph, { color: "secondary", children: "This integration is not properly configured and could not be loaded. Please contact your administrator." })
    ] });
  if (!s)
    return /* @__PURE__ */ r(N, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ r(
      le.Item,
      {
        contentLeft: g,
        title: "Something went wrong. Please try again later.",
        variant: "dense"
      }
    ) });
  const f = e?.graphQLErrors || [];
  return /* @__PURE__ */ h(
    N,
    {
      margin: "200 0 300",
      flexDirection: "column",
      className: Y.errorWrapper,
      children: [
        f.map((l, p) => {
          const d = l?.extensions?.integration, y = d?.message || e?.message || "No error message available", b = d?.responseBody && JSON.parse(d?.responseBody), w = b?.errorMessages || [], E = b?.warningMessages || [], c = [...w, ...E].join(" ");
          return /* @__PURE__ */ r(
            le.Item,
            {
              title: y,
              titleSecondary: c,
              contentLeft: g
            },
            p
          );
        }),
        !o && /* @__PURE__ */ h(N, { margin: "200 0 300", flexDirection: "column", gap: "200", children: [
          /* @__PURE__ */ r(
            he,
            {
              variant: "info",
              description: /* @__PURE__ */ r(T.Paragraph, { variant: "4", children: "Please copy the error details by clicking on the button below and include them in your support request." })
            }
          ),
          /* @__PURE__ */ h(N, { flexDirection: "row", gap: "200", justifyContent: "space-between", children: [
            t && /* @__PURE__ */ r(W, { variant: "secondary", icon: "sync", onClick: () => t(), children: "Retry" }),
            /* @__PURE__ */ r(
              W,
              {
                variant: "secondary",
                icon: a ? "done" : "copy",
                onClick: () => u(JSON.stringify(f, null, 2)),
                className: Y.copyIcon,
                children: "Copy error payload"
              }
            )
          ] })
        ] })
      ]
    }
  );
}, bt = ({
  headline: e,
  text: t,
  children: n,
  onConfirm: o,
  onCancel: i,
  confirmLabel: s,
  cancelLabel: a = "Cancel",
  confirmVariant: u = "primary",
  cancelVariant: g = "secondary",
  isOpen: f,
  setIsOpen: l,
  showOnClose: p = !1
}) => /* @__PURE__ */ h(
  Ge,
  {
    isOpen: f,
    onClose: () => {
      i && i(), l(!1);
    },
    children: [
      /* @__PURE__ */ r(
        He,
        {
          title: e,
          onClose: p ? i : void 0
        }
      ),
      /* @__PURE__ */ h(qe, { children: [
        t && /* @__PURE__ */ r("div", { style: { width: "600px" }, children: t }),
        n
      ] }),
      /* @__PURE__ */ r(
        Ke,
        {
          confirmOnClick: o ? () => {
            o(), l(!1);
          } : void 0,
          cancelOnClick: () => {
            i && i(), l(!1);
          },
          confirmName: s,
          cancelName: a,
          confirmProps: { variant: u },
          cancelProps: { variant: g }
        }
      )
    ]
  }
), oe = "The configuration of the integration is not correct. Please check the settings.", xn = ({
  cause: e
}) => /* @__PURE__ */ r(N, { margin: "0 0 400", children: /* @__PURE__ */ r(
  he,
  {
    variant: "fail",
    headline: "This integration is misconfigured",
    description: /* @__PURE__ */ h(N, { gap: "300", flexDirection: "column", children: [
      /* @__PURE__ */ r(T.Paragraph, { children: e || oe }),
      /* @__PURE__ */ h(N, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ r(T.Heading, { variant: "heading-3", children: "Additional information" }),
        /* @__PURE__ */ r(T.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
      ] })
    ] })
  }
) }), In = ({
  form: e,
  integrationId: t,
  onValidSubmit: n,
  error: o,
  onRetry: i,
  isLoading: s,
  isWidgetUnknown: a,
  children: u
}) => o ? /* @__PURE__ */ r(Ne, { error: o, retry: i }) : s ? /* @__PURE__ */ r(te, { "data-testid": "widget-settings-loading" }) : a ? /* @__PURE__ */ h(T.Paragraph, { children: [
  "A widget with the id ",
  /* @__PURE__ */ r(Qe, { children: t }),
  " does not exist."
] }) : /* @__PURE__ */ r(Ze, { ...e, children: /* @__PURE__ */ r(
  "form",
  {
    noValidate: !0,
    tabIndex: -1,
    "data-testid": `widget-settings-form-${t ?? "create-new"}`,
    onSubmit: e.handleSubmit(n),
    children: u
  }
) });
function Pn(e, t = !0) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return t && console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const _n = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, Wn = (e) => {
  const t = et(e);
  return t.length === 0 ? e : tt(t);
}, Se = "DD MMM YYYY @ HH:mm";
function Et(e, t) {
  return e == null ? t : typeof e == "boolean" ? e : e === "true";
}
function At(e, t) {
  return e == null ? t : String(e);
}
function kn(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const Rn = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], Bn = (e) => {
  if (!e?.trim())
    return "Please add a valid subdomain";
  const n = ["https://", "http://"].find(
    (s) => e.startsWith(s)
  ), o = n ? `Please remove the protocol \`${n}\` from the hostname` : "", i = e.endsWith("/") ? "Please remove the trailing `/` from the hostname" : "";
  if (o && i)
    return `Please remove the protocol \`${n}\` and the trailing \`/\` from the hostname`;
  if (o)
    return o;
  if (i)
    return i;
};
function Nt(e) {
  const t = e.split(".")[1];
  if (!t)
    throw Error("Invalid token");
  const n = t.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(atob(n).toString());
  } catch (o) {
    throw Error(
      `Failed to parse the JSON Web Token with the following error: ${o}`
    );
  }
}
const re = ["==", "!="], St = [
  ...re
], vt = [
  ...re,
  "begins_with",
  "ends_with",
  "matches"
  // regex - https://github.com/dixahq/elevion/blob/f07a08fb5b0229925b1e42a2efad12870e3d46e1/elevion/src/test/scala/com/elevio/elevion/parser/ElevionParserTest.scala#L25
], Tt = [
  "contains_one",
  "contains_all",
  "is_empty"
], Mt = ["between", "not_between"], ve = [
  ...re,
  ">",
  "<"
], Te = [
  "before",
  "after",
  ...ve
], Dt = Te;
[
  // remove duplicates using Set
  .../* @__PURE__ */ new Set([
    ...St,
    ...vt,
    ...Tt,
    ...Mt,
    ...Te,
    ...Dt,
    ...ve
  ])
];
const Ot = "custom__";
var X = /* @__PURE__ */ ((e) => (e.Queue = "system__queue", e.Tags = "system__tags", e))(X || {});
const xt = (e) => e === X.Queue ? "Queue" : e === X.Tags ? "Tags" : e.startsWith(Ot) ? "Custom attribute" : e, Me = (e, t) => {
  if ("logicalOp" in e) {
    e.nodes.forEach((n) => Me(n, t));
    return;
  }
  t.add(xt(e.field));
}, It = (e) => {
  const t = /* @__PURE__ */ new Set();
  return e.forEach((n) => Me(n, t)), [...t].sort().join(", ");
}, ue = (e, t, n, o) => {
  const i = n.length > 0, s = It(n);
  if (t) {
    i && e("settings:condition:created", { conditionType: s });
    return;
  }
  i ? e("settings:condition:updated", { conditionType: s }) : o && e("settings:condition:deleted", {});
}, De = Ce(null);
function Pt() {
  const e = ye(De);
  if (e === null)
    throw Error(
      "useInboundOAuthContext requires InboundOAuthContext to be used higher up in the component tree, below InboundOAuthContext.Provider"
    );
  return e;
}
function _t() {
  return {
    isInboundOAuth: !1,
    setIsInboundOAuth: () => {
    },
    hasTriggeredAuthorization: !1,
    setHasTriggeredAuthorization: () => {
    }
  };
}
const Oe = Ce(null), Wt = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Oe.Provider
);
function xe() {
  const e = ye(Oe);
  if (e === null)
    throw Error(
      "useWidgetContext requires WidgetContext to be used higher up in the component tree, below WidgetContextProvider"
    );
  return e;
}
function Ln() {
  window._partner = {
    events: { emit: () => {
    } }
  };
}
const kt = {
  useMutation: G,
  useQuery: () => {
  },
  useLazyQuery: () => {
  },
  executeQuery: () => {
  },
  showNotification: () => {
  },
  showModal: () => {
  }
}, Rt = {
  baseUrl: "http://localhost/graphql"
};
function $n(e, { mocks: t = [], overrides: n = {} } = {}) {
  const o = vi.fn(), i = vi.fn(), a = { ...{
    configuration: Rt,
    handleRedirect: o,
    showNotification: i
  }, ...n };
  return { ...it(
    V(
      rt,
      { mocks: t },
      V(
        De.Provider,
        { value: _t() },
        V(
          Wt,
          { value: kt },
          V(e, a)
        )
      )
    )
  ), handleRedirect: o, showNotification: i };
}
function Fn({
  id: e,
  configuration: t
}) {
  const n = t?.settings ?? [];
  return {
    request: {
      query: ne,
      variables: { id: e }
    },
    result: {
      data: {
        Management: {
          widgetConfigurations: [
            {
              id: e,
              type: t?.type ?? "UNKNOWN",
              name: t?.name ?? "Test widget",
              enabled: t?.enabled ?? !0,
              misconfigured: t?.misconfigured ?? !1,
              misconfigurationCause: t?.misconfigurationCause ?? null,
              additionalProperties: t?.additionalProperties ?? null,
              renderConditions: t?.renderConditions ?? [],
              settings: n
            }
          ]
        }
      }
    }
  };
}
function Un({
  variables: e,
  result: t
}) {
  const n = {
    ...e,
    renderConditions: e.renderConditions ?? []
  };
  return {
    request: {
      query: Ee,
      variables: n
    },
    result: {
      data: {
        Management: {
          createWidgetConfiguration: {
            id: t?.id ?? "new-id",
            name: t?.name ?? e.name,
            enabled: t?.enabled ?? e.enabled,
            misconfigured: t?.misconfigured ?? !1,
            misconfigurationCause: t?.misconfigurationCause ?? null,
            additionalProperties: t?.additionalProperties ?? null,
            renderConditions: t?.renderConditions ?? n.renderConditions,
            settings: t?.settings ?? []
          }
        }
      }
    }
  };
}
function Gn({
  variables: e,
  result: t
}) {
  return {
    request: {
      query: be,
      variables: e
    },
    result: {
      data: {
        Management: {
          updateWidgetConfiguration: {
            id: e.id,
            name: t?.name ?? e.name,
            enabled: t?.enabled ?? e.enabled ?? !0,
            misconfigured: t?.misconfigured ?? !1,
            misconfigurationCause: t?.misconfigurationCause ?? null,
            additionalProperties: t?.additionalProperties ?? null,
            renderConditions: t?.renderConditions ?? e.renderConditions ?? [],
            settings: t?.settings ?? []
          }
        }
      }
    }
  };
}
function Hn({
  id: e
}) {
  return {
    request: {
      query: Ae,
      variables: { id: e }
    },
    result: {
      data: {
        Management: {
          deleteWidgetConfiguration: { id: e }
        }
      }
    }
  };
}
function Bt(e, t) {
  const n = {};
  for (const o of t) {
    const s = e.find((a) => a.key === o.key)?.value;
    o.secret && s === void 0 || (o.type === "boolean" ? n[o.key] = Et(s, o.defaultValue) : n[o.key] = At(s, o.defaultValue));
  }
  return n;
}
function Lt(e, t) {
  return t.filter((n) => e[n.key] !== void 0).map((n) => ({
    key: n.key,
    value: String(e[n.key]),
    secret: n.secret
  }));
}
async function qn(e, {
  fieldDefinitions: t,
  isCreationMode: n,
  create: o,
  update: i,
  renderConditions: s
}) {
  const a = Lt(e, t), u = {
    name: e.name,
    enabled: e.enabled,
    settings: a,
    ...s !== void 0 && { renderConditions: s }
  };
  n ? await o(u) : await i(u);
}
function $t(e) {
  const { user_id: t, iss: n } = Nt(e);
  return {
    "x-integration-user-id": t,
    "x-integration-organization-id": n
  };
}
function Ft(e) {
  return e.startsWith("http://localhost");
}
function ie() {
  return { track: (t, n) => window._partner.events.emit(t, n) };
}
const Ut = (e) => {
  switch (e) {
    case "CONNECTED":
      return {
        icon: "check-circle-filled",
        color: P.green[500],
        tooltip: "Connected"
      };
    case "CONNECTING":
      return {
        icon: "sync",
        color: P.neutral[500],
        tooltip: "Connecting.."
      };
    case "CONNECTION_FAILED":
      return {
        icon: "close-circle-filled",
        color: P.red[500],
        tooltip: "Connection failed"
      };
    case "CONNECTION_TIMEOUT":
      return {
        icon: "exclamation-triangle-filled",
        color: P.red[200],
        tooltip: "Connection timeout"
      };
    default:
      return {
        icon: "exclamation-circle-filled",
        color: P.neutral[500],
        tooltip: "Not connected"
      };
  }
}, Kn = ({
  configuration: e,
  integrationId: t,
  integrationType: n,
  label: o
}) => {
  const [i, s] = m("CONNECTING"), [a, u] = m(""), [g, f] = m(null), { track: l } = ie(), { icon: p, color: d, tooltip: y } = Ut(i), b = 3, w = 15, E = 2e3, [c, M] = m({}), [v, C] = m(0), [x, q] = m(E), [D, _] = m(!1), [R, L] = m(b), {
    isInboundOAuth: Ie,
    setIsInboundOAuth: Pe,
    hasTriggeredAuthorization: _e,
    setHasTriggeredAuthorization: We
  } = Pt(), { baseUrl: K } = e, ke = `${K}/auth/connect/${n.toLowerCase()}/${t}`, Re = `${K}/auth/status/${n.toLowerCase()}/${t}`, se = i === "CONNECTING", ae = (A) => Object.keys(A).length === 0, J = () => {
    _(!1), C(0);
  };
  S(() => {
    const A = localStorage.getItem("authData");
    if (A) {
      const I = JSON.parse(A ?? "{}").access_token;
      M({
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${I}`,
          ...Ft(K) && $t(I)
        }
      });
    }
  }, [K]), S(() => {
    ae(c) || _(!0);
  }, [c]);
  const Be = () => {
    L(w), fetch(Re, { ...c }).then((A) => A.json()).then(({ data: A }) => {
      const { status: $, createdAt: I, createdByName: F } = A;
      switch ($) {
        case "CONNECTING":
          s("CONNECTING");
          break;
        case "CONNECTED": {
          if (l("settings:view:oauth:succeeded", {
            widgetId: t,
            widgetType: n
          }), s("CONNECTED"), I && F) {
            const Q = new Date(I);
            isNaN(Q.getTime()) || f(Q), u(F);
          }
          J();
          break;
        }
        case "NOT_CONNECTED":
        case "CONNECTION_FAILED":
          s($), J();
      }
    }).catch((A) => {
      console.warn(
        `Fetching OAuth status failed for ${n} ${t}`,
        A
      ), s("CONNECTION_FAILED");
    });
  };
  Xe(
    () => {
      v >= R ? (s("CONNECTION_TIMEOUT"), J()) : (Be(), C(v + 1));
    },
    D ? x : null
  );
  const ce = () => {
    l("settings:view:oauth:started", {
      widgetId: t,
      widgetType: n
    }), fetch(ke, { ...c }).then((A) => A.json()).then(({ data: A }) => {
      const { url: $ } = A, I = 620, F = 800, Q = window.innerWidth / 2 - I / 2, Le = window.innerHeight / 2 - F / 2;
      s("CONNECTING"), _(!0), window.open(
        $,
        "DixaPartnerOAuth",
        `toolbar=no,
						location=no,
						status=no,
						menubar=no,
						scrollbars=yes,
						resizable=yes,
						width=${I},
						height=${F},
						left=${Q},
						top=${Le}`
      );
    }).catch((A) => {
      console.warn(
        `Fetching OAuth connection failed for ${n} ${t}`,
        A
      ), s("CONNECTION_FAILED");
    });
  };
  return S(() => {
    Ie && !_e && !ae(c) && (We(!0), Pe(!1), ce());
  }, [c]), /* @__PURE__ */ h(B, { children: [
    /* @__PURE__ */ r(H, { span: 3, children: /* @__PURE__ */ r(
      O,
      {
        label: o,
        meta: {
          warning: "All agents interact with the widget using your access permissions."
        },
        style: { marginBottom: 20 },
        children: /* @__PURE__ */ h(N, { flexDirection: "row", alignItems: "baseline", gap: "300", children: [
          /* @__PURE__ */ r(
            W,
            {
              icon: "key",
              variant: "secondary",
              onClick: ce,
              disabled: se,
              style: { marginBottom: 8 },
              children: "Start authorization"
            }
          ),
          /* @__PURE__ */ r(fe, { content: y, children: se ? /* @__PURE__ */ r(te, { "data-testid": "oauth-button-spinner", size: 18 }) : /* @__PURE__ */ h(N, { alignItems: "center", gap: "200", children: [
            /* @__PURE__ */ r(
              ee,
              {
                "data-testid": "oauth-button-status-icon",
                name: p,
                color: d
              }
            ),
            i === "CONNECTED" && a && g && /* @__PURE__ */ h(T.Paragraph, { variant: "4", subdued: !0, children: [
              "Authorized by ",
              a,
              " at",
              " ",
              we(g).format(Se)
            ] })
          ] }) })
        ] })
      }
    ) }),
    /* @__PURE__ */ r(H, { span: 3 })
  ] });
}, Gt = "_settingsWrapper_eleyu_1", Ht = {
  settingsWrapper: Gt
}, qt = k`
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_get_lists_response {
          ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
            data {
              type
              id
              attributes {
                name
                created
                updated
              }
              links {
                self
              }
            }
            links {
              self
            }
          }
          ... on Klaviyo_ClientError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
          ... on Klaviyo_ServerError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
        }
      }
    }
  }
`, ge = [], Qn = ({
  settings: e,
  getValueByKey: t,
  handleChangeSelect: n
}) => {
  const o = "subscriptionListId", s = e?.find(
    (c) => c.key === o
  )?.label ?? "Activate re-/subscription list selection", a = t(o)?.value, { useQuery: u } = xe(), [g, f] = m(ge), [l, p] = m(!!a), [d, y] = m(a), {
    data: b,
    error: w,
    loading: E
  } = u(qt, {
    skip: !l,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return S(() => {
    a && (y(a), p(!0));
  }, [a]), S(() => {
    const c = b?.Klaviyo?.get_lists;
    if (l && c && !E && !w) {
      const M = c?.data?.map(
        (v) => ({
          value: v?.id,
          label: v?.attributes?.name
        })
      ) || ge;
      f(M);
    }
  }, [l, b, E, w]), /* @__PURE__ */ h(B, { children: [
    /* @__PURE__ */ r(H, { span: 3, children: /* @__PURE__ */ h(
      N,
      {
        gap: "300",
        flexDirection: "column",
        className: Ht.settingsWrapper,
        children: [
          /* @__PURE__ */ r(O, { label: s, children: /* @__PURE__ */ r(
            Ve,
            {
              input: {
                name: `${o}-switch`,
                value: "switchValueFromComponent",
                checked: l,
                onChange: () => {
                  const c = !l;
                  c || n(o, {
                    selectedValues: [
                      {
                        label: "",
                        value: ""
                      }
                    ]
                  }), p(c);
                }
              }
            }
          ) }),
          l && w && !E && /* @__PURE__ */ r(O, { children: /* @__PURE__ */ r(Ne, { error: w }) }),
          l && !w && E && /* @__PURE__ */ r(O, { children: /* @__PURE__ */ r(N, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ r(te, {}) }) }),
          l && !w && !E && g && /* @__PURE__ */ r(O, { label: "Available lists to subscribe to", children: /* @__PURE__ */ r(
            ze,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (c) => {
                n(o, c), y(c?.selectedValues?.[0].value);
              },
              getItemTitleByValue: (c) => c ? /* @__PURE__ */ r(T.Paragraph, { children: c.label }) : null,
              value: d ? [
                {
                  label: (g || []).find(
                    (c) => c.value === d
                  )?.label,
                  value: d
                }
              ] : [],
              equalityFn: (c, M) => c.value === M.value,
              children: g.map((c) => /* @__PURE__ */ r(Je.Item, { value: c, children: c.label }, c.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ r(H, { span: 3 })
  ] });
}, Vn = (e) => {
  if (e == null)
    return null;
  if (Array.isArray(e))
    return /* @__PURE__ */ r(T.Paragraph, { variant: "5", color: "secondary", align: "right", children: e.join(", ") });
  if (typeof e == "boolean" || e === "true" || e === "false") {
    const o = e === "true" || e === !0;
    return /* @__PURE__ */ r(
      ee,
      {
        name: o ? "check-circle-filled" : "close-circle-filled",
        color: o ? P.green[500] : P.red[500],
        size: 14,
        "data-testid": `displayAttributeValue-icon-${o ? "true" : "false"}`
      }
    );
  }
  if (typeof e == "number" || /^\d*\.?\d+$/.test(e))
    return /* @__PURE__ */ r(j, { variant: "success", size: "small", children: e });
  if (e.startsWith("days_ago: ")) {
    const o = e.replace("days_ago: ", ""), i = o.startsWith("-"), s = o === "0", a = i ? `${o.replace("-", "")} days ago` : `in ${o} days`;
    return /* @__PURE__ */ r(T.Paragraph, { variant: "5", color: "secondary", children: s ? "today" : a });
  }
  const n = we(e);
  return n.isValid() ? /* @__PURE__ */ r(T.Paragraph, { variant: "5", color: "secondary", children: n.format(Se) }) : /* @__PURE__ */ r(j, { variant: "info", size: "small", children: e });
}, zn = (e) => {
  const { isCreationMode: t = !1, label: n, helpIcon: o, name: i } = e, [s, a] = m(t);
  if (!s) {
    const u = typeof n == "string" ? n : "";
    return /* @__PURE__ */ r(O, { label: n, helpIcon: o, children: /* @__PURE__ */ h(
      W,
      {
        "data-testid": `secret-field-button-${i}`,
        variant: "secondary",
        icon: "pen",
        onClick: () => a(!0),
        children: [
          "Update ",
          u
        ]
      }
    ) });
  }
  return /* @__PURE__ */ r(
    Kt,
    {
      ...e,
      isCreationMode: t,
      onClose: () => a(!1)
    }
  );
}, Kt = (e) => {
  const { isCreationMode: t, componentProps: n, onClose: o } = e, i = {
    ...n,
    prefix: t ? n?.prefix : {
      type: "button",
      button: { icon: "close", onClick: o }
    }
  };
  return /* @__PURE__ */ r(
    nt,
    {
      ...e,
      componentProps: i,
      shouldUnregister: !0
    }
  );
}, Qt = "_wrapper_1lmim_1", Vt = "_wrapperBox_1lmim_4", zt = "_wrapperBoxErrorBorder_1lmim_9", Z = {
  wrapper: Qt,
  wrapperBox: Vt,
  wrapperBoxErrorBorder: zt
}, me = (e, t) => e !== "" && t !== "" ? window.btoa(`${e}:${t}`) : "", Jn = (e) => {
  const { isCreationMode: t = !1, label: n, name: o } = e, [i, s] = m(t);
  if (!i) {
    const a = typeof n == "string" ? n : "";
    return /* @__PURE__ */ r(O, { label: n, children: /* @__PURE__ */ h(
      W,
      {
        "data-testid": `secret-field-button-${o}`,
        variant: "secondary",
        icon: "pen",
        onClick: () => s(!0),
        children: [
          "Update ",
          a
        ]
      }
    ) });
  }
  return /* @__PURE__ */ r(
    Jt,
    {
      ...e,
      isCreationMode: t,
      onClose: () => s(!1)
    }
  );
}, Jt = (e) => {
  const {
    name: t,
    control: n,
    label: o,
    rules: i,
    isCreationMode: s,
    usernameLabel: a,
    passwordLabel: u,
    usernamePlaceholder: g,
    passwordPlaceholder: f,
    onClose: l
  } = e, { field: p, fieldState: d } = je({
    name: t,
    control: n,
    rules: i,
    shouldUnregister: !0
  }), [y, b] = m(""), [w, E] = m(""), c = (C) => {
    b(C), p.onChange(me(C, w));
  }, M = (C) => {
    E(C), p.onChange(me(y, C));
  }, v = !!i?.required;
  return /* @__PURE__ */ r(
    O,
    {
      label: o,
      required: v,
      meta: {
        touched: d.isTouched,
        error: d.error?.message
      },
      className: Z.wrapper,
      children: /* @__PURE__ */ h(
        N,
        {
          gap: "300",
          flexDirection: "column",
          className: ot(Z.wrapperBox, {
            [Z.wrapperBoxErrorBorder]: !!d.error
          }),
          children: [
            /* @__PURE__ */ r(
              de,
              {
                noAlert: !0,
                required: v,
                label: a,
                placeholder: g,
                input: {
                  name: t,
                  value: y,
                  onChange: (C) => c(C?.target.value ?? ""),
                  onBlur: p.onBlur
                },
                ...!s && {
                  prefix: {
                    type: "button",
                    button: { icon: "close", onClick: l }
                  }
                }
              }
            ),
            /* @__PURE__ */ r(
              de,
              {
                noAlert: !0,
                required: v,
                label: u,
                placeholder: f,
                input: {
                  name: t,
                  value: w,
                  onChange: (C) => M(C?.target.value ?? ""),
                  onBlur: p.onBlur
                },
                ...!s && {
                  prefix: {
                    type: "button",
                    button: { icon: "close", onClick: l }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
}, Yt = {
  submit: "Submit",
  delete: "Delete",
  confirmDelete: "Yes",
  cancelDelete: "No"
}, Yn = ({
  integrationType: e,
  integrationId: t,
  widgetName: n,
  isCreationMode: o,
  isSubmitting: i,
  automationCouplingState: s,
  onConfirmDelete: a,
  labels: u,
  deleteConfirmationBody: g,
  confirmDeleteVariant: f = "primary"
}) => {
  const { track: l } = ie(), [p, d] = m(!1), y = { ...Yt, ...u }, b = !s || !s.isCoupled, w = () => {
    t && l("settings:view:delete:requested", {
      widgetId: t,
      widgetType: e
    }), d(!0);
  }, E = () => {
    t && l("settings:view:delete:canceled", {
      widgetId: t,
      widgetType: e
    });
  };
  return /* @__PURE__ */ h(B, { children: [
    /* @__PURE__ */ h(N, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ r(W, { type: "submit", isLoading: i, disabled: i, children: y.submit }),
      !o && /* @__PURE__ */ r(
        fe,
        {
          content: "The widget is used in automations",
          disabled: b,
          children: /* @__PURE__ */ r(
            W,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              type: "button",
              onClick: w,
              disabled: !b,
              isLoading: s?.isLoading,
              children: y.delete
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ r(
      bt,
      {
        isOpen: p,
        setIsOpen: d,
        confirmVariant: f,
        confirmLabel: y.confirmDelete,
        cancelLabel: y.cancelDelete,
        onCancel: E,
        onConfirm: a,
        children: /* @__PURE__ */ r(N, { children: g ?? /* @__PURE__ */ h(B, { children: [
          "Are you sure you want to delete the ",
          e,
          ' integration "',
          n,
          '"?'
        ] }) })
      }
    )
  ] });
}, Zt = k`
  query read($conversationId: String!) {
    Storage {
      widgetData(conversation: $conversationId)
    }
  }
`, jt = k`
  mutation store($conversationId: String!, $data: Storage_JSONObject) {
    Storage {
      storeWidgetData(conversation: $conversationId, data: $data) {
        data
      }
    }
  }
`;
function Zn(e) {
  const { useQuery: t, useMutation: n } = xe(), [o, i] = m(), [s, a] = m(), [u, g] = m(!1), {
    loading: f,
    data: l,
    error: p
  } = t(
    Zt,
    {
      skip: !e,
      variables: {
        conversationId: e?.toString()
      }
    }
  ), [d, { loading: y, error: b }] = n(
    jt
  ), w = async (E, c) => await d({
    variables: {
      conversationId: (c ?? e)?.toString(),
      data: E
    }
  }).then(
    ({ data: v }) => i(v?.Storage?.storeWidgetData?.data ?? {})
  );
  return S(() => {
    !f && l && i(l?.Storage?.widgetData ?? {});
  }, [l, f]), S(() => p && a(p), [p]), S(() => g(f), [f]), S(() => b && a(b), [b]), S(() => g(y), [y]), {
    data: o,
    loading: u,
    store: w,
    error: s
  };
}
const jn = ({
  integrationId: e,
  integrationType: t,
  handleRedirect: n,
  showNotification: o
}) => {
  const { track: i } = ie(), [s, a] = m(!1), [u, g] = m(), [f, l] = m(null), p = U(
    (C) => (x) => {
      g(x), a(!1), o({
        title: "Something went wrong",
        text: `The ${C} of the widget was not successful.`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    [o]
  ), [d] = G(Ee, {
    onError: p("creation")
  }), [y] = G(be, {
    onError: p("update")
  }), [b] = G(Ae, {
    onError: p("deletion")
  }), w = Ue(), E = U(() => e ? !!w.readQuery({
    query: ne,
    variables: { id: e }
  })?.Management?.widgetConfigurations?.[0]?.renderConditions?.length : !1, [w, e]), c = U(
    async ({
      name: C,
      enabled: x,
      settings: q,
      renderConditions: D = []
    }) => {
      i("settings:create:submitted", { widgetType: t }), a(!0), g(void 0);
      const { data: _ } = await d({
        variables: {
          type: t,
          name: C,
          enabled: x,
          settings: q,
          renderConditions: D
        }
      });
      a(!1);
      const R = _?.Management?.createWidgetConfiguration;
      if (!R) {
        o({
          title: "Something went wrong",
          text: "The creation of the widget was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
        return;
      }
      ue(i, !0, D, !1), o({
        title: "Creating was successful",
        text: "Creating the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), n(R.id);
    },
    [d, n, t, o, i]
  ), M = U(
    async ({
      name: C,
      enabled: x,
      settings: q,
      renderConditions: D
    }) => {
      if (!e)
        return;
      i("settings:view:change:submitted", {
        widgetId: e,
        widgetType: t
      });
      const _ = E();
      a(!0), g(void 0);
      const { data: R } = await y({
        variables: {
          id: e,
          name: C,
          enabled: x,
          settings: q,
          ...D !== void 0 && { renderConditions: D }
        }
      });
      a(!1);
      const L = R?.Management?.updateWidgetConfiguration;
      if (!L) {
        o({
          title: "Something went wrong",
          text: "The update of the widget was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
        return;
      }
      L.misconfigured ? l(
        L.misconfigurationCause ?? oe
      ) : l(null), D && ue(
        i,
        !1,
        D,
        _
      ), o({
        title: "Updating was successful",
        text: "Updating the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    },
    [
      e,
      t,
      E,
      o,
      i,
      y
    ]
  ), v = U(async () => {
    if (!e)
      return;
    i("settings:view:delete:confirmed", {
      widgetId: e,
      widgetType: t
    }), a(!0), g(void 0);
    const { data: C } = await b({
      variables: { id: e }
    });
    a(!1), C?.Management?.deleteWidgetConfiguration && (n(), o({
      title: "Deletion was successful",
      text: "The deletion of the widget was successful.",
      icon: "check-circle-filled",
      severity: "success"
    }));
  }, [
    b,
    n,
    e,
    t,
    o,
    i
  ]);
  return {
    create: c,
    update: M,
    remove: v,
    isLoading: s,
    error: u,
    misconfigurationCause: f,
    setMisconfigurationCause: l
  };
};
function Xn({
  integrationId: e,
  fieldDefinitions: t,
  form: n,
  onMisconfigured: o
}) {
  const [i, s] = m(!1), [a, u] = m(), { loading: g, error: f, refetch: l } = pe(ne, {
    variables: { id: e },
    skip: !e,
    onCompleted: (p) => {
      const d = p?.Management?.widgetConfigurations?.[0];
      if (!d) {
        s(!0), u(void 0);
        return;
      }
      s(!1), u(d), n.reset({
        ...Bt(d.settings ?? [], t),
        enabled: !!d.enabled,
        name: d.name
      }), d.misconfigured && o?.(
        d.misconfigurationCause ?? oe
      );
    }
  });
  return S(() => {
    s(!1), u(void 0);
  }, [e]), {
    isLoading: g,
    error: f,
    isWidgetUnknown: i,
    refetch: l,
    widgetConfiguration: a
  };
}
function eo({
  integrationId: e,
  widgetConfiguration: t,
  renderConditionsEditor: n
}) {
  const o = !e, [i, s] = m(o ? [] : null);
  return S(() => {
    s(o ? [] : null);
  }, [e, o]), S(() => {
    t && i === null && s(t.renderConditions ?? []);
  }, [t, i]), {
    renderConditions: i,
    setRenderConditions: s,
    renderConditionsForSubmit: !!n && i !== null && i !== null ? i : void 0
  };
}
export {
  Ne as DisplayErrors,
  bn as DixaApiTokenSettings,
  De as InboundOAuthContext,
  bt as IntegrationModal,
  Qn as KlaviyoSubscribeSetting,
  xn as MisconfigurationBanner,
  Kn as OAuthSettings,
  Jn as PartnerHookFormBasicAuth,
  zn as PartnerHookFormSecretText,
  In as PartnerSettingsWrapper,
  Wt as WidgetContextProvider,
  Yn as WidgetSettingsFormFooter,
  _n as capitalizeFirstCharacter,
  Rn as countryCodes,
  _t as createMockInboundOAuthContextOptions,
  Un as createWidgetConfigurationCreateMock,
  Hn as createWidgetConfigurationDeleteMock,
  Ee as createWidgetConfigurationMutation,
  Fn as createWidgetConfigurationQueryMock,
  Gn as createWidgetConfigurationUpdateMock,
  Pn as deepClone,
  Se as defaultDateFormat,
  oe as defaultMisconfigurationCause,
  Rt as defaultPartnerSettingsConfiguration,
  kt as defaultWidgetContextValue,
  Ae as deleteWidgetConfigurationMutation,
  Vn as displayAttributeValue,
  Lt as formValuesToSettings,
  It as getConditionType,
  Ut as getConnectionStatusValues,
  kn as getCountryNameFromCountryCode,
  qt as getListsQuery,
  $t as getPartnerDevApiHeaders,
  ne as getWidgetConfigurationByIdQuery,
  qn as handleWidgetSubmit,
  En as hasDixaHeaderCheckError,
  An as hasDownstreamApiAuthorizationError,
  Mn as hasDownstreamApiBadRequestError,
  Tn as hasDownstreamApiConflictError,
  Dn as hasDownstreamApiForbiddenError,
  vn as hasDownstreamApiNotFoundError,
  Nn as hasDownstreamApiPermissionError,
  Sn as hasDownstreamApiServiceUnavailableError,
  On as hasDownstreamApiTooManyRequestsError,
  ft as hasWidgetMisconfiguredError,
  Wn as humanizeKey,
  st as isDixaHeaderCheckError,
  at as isDownstreamApiAuthorizationError,
  gt as isDownstreamApiBadRequestError,
  ut as isDownstreamApiConflictError,
  mt as isDownstreamApiForbiddenError,
  dt as isDownstreamApiNotFoundError,
  ct as isDownstreamApiPermissionError,
  lt as isDownstreamApiServiceUnavailableError,
  pt as isDownstreamApiTooManyRequestsError,
  Ft as isRunningLocalPartnerApi,
  ht as isWidgetMisconfiguredError,
  yn as makeExecuteQuery,
  Cn as makeUseLazyQuery,
  wn as makeUseMutation,
  fn as makeUseQuery,
  Nt as parseAccessToken,
  Et as parseBoolean,
  At as parseString,
  $n as renderPartnerSettings,
  Bt as settingsToFormValues,
  Ln as stubPartnerEventsBusForTests,
  ue as trackRenderConditionsSaved,
  be as updateWidgetConfigurationMutation,
  Ct as useCopyWithDelay,
  Zn as useData,
  Pt as useInboundOAuthContext,
  eo as useRenderConditions,
  ie as useTracking,
  xe as useWidgetContext,
  jn as useWidgetSettingsMutations,
  Xn as useWidgetSettingsQuery,
  Bn as validateApiHostName
};
